import React from 'react';
import VAEPresentation from '../VAEPresentation';
import DEAPPresentation from '../DEAPPresentation';
import DEEJEPresentation from '../DEEJEPresentation';
import CAFERUISPresentation from '../CAFERUISPresentation';
import CAFBC1Presentation from '../CAFBC1Presentation';
import CAFBC2Presentation from '../CAFBC2Presentation';
import CAFBC3Presentation from '../CAFBC3Presentation';
import CAFBC4Presentation from '../CAFBC4Presentation';
import CAFBC5Presentation from '../CAFBC5Presentation';
import DEASPresentation from '../DEASPresentation';
import BACASSPPresentation from '../BACASSPPresentation';
import TPIEPEPresentation from '../TPIEPEPresentation';
import TPIEPEBloc1Presentation from '../TPIEPEBloc1Presentation';
import TPIEPEBloc2Presentation from '../TPIEPEBloc2Presentation';
import TPIEPEBloc3Presentation from '../TPIEPEBloc3Presentation';
import TPIEPEEtudeCasBloc1 from '../TPIEPEEtudeCasBloc1';
import DEAPActivite1Presentation from '../DEAPActivite1Presentation';
import DEAPActivite1bisPresentation from '../DEAPActivite1bisPresentation';
import DEAPActivite2Presentation from '../DEAPActivite2Presentation';
import DEAPActivite3Presentation from '../DEAPActivite3Presentation';
import DEAPActivite4Presentation from '../DEAPActivite4Presentation';
import DEAPActivite5Presentation from '../DEAPActivite5Presentation';
import DEAPActivite6Presentation from '../DEAPActivite6Presentation';
import DEAPActivite7Presentation from '../DEAPActivite7Presentation';
import DEAPActivite8Presentation from '../DEAPActivite8Presentation';
import DEAPActivite9Presentation from '../DEAPActivite9Presentation';
import DEAPActivite10Presentation from '../DEAPActivite10Presentation';
import DEAPActivite11Presentation from '../DEAPActivite11Presentation';
import OralVAEPresentation from '../OralVAEPresentation';
import DEEJEDC1Presentation from '../DEEJEDC1Presentation';
import DEEJEDC2Presentation from '../DEEJEDC2Presentation';
import DEEJEDC3Presentation from '../DEEJEDC3Presentation';
import DEEJEDC4Presentation from '../DEEJEDC4Presentation';
import DEEJEPedagoguesPresentation from '../DEEJEPedagoguesPresentation';
import DEEJEGlossairePresentation from '../DEEJEGlossairePresentation';
import DEEJELoisPresentation from '../DEEJELoisPresentation';
import BACASSPPresentationGenerale from '../BACASSPPresentationGenerale';
import BACASSPBloc1Approche from '../BACASSPBloc1Approche';
import BACASSPBloc2Approche from '../BACASSPBloc2Approche';
import BACASSPBloc3Approche from '../BACASSPBloc3Approche';
import BACASSPBloc4Approche from '../BACASSPBloc4Approche';
import BACASSPPSEPresentation from '../BACASSPPSEPresentation';
import BACASSPOutilsPresentation from '../BACASSPOutilsPresentation';
import FormationLangagePresentation from '../FormationLangagePresentation';

const PRESENTATION_MAP = {
  'caferuis': CAFERUISPresentation,
  'caferuis-bc1': CAFBC1Presentation,
  'caferuis-bc2': CAFBC2Presentation,
  'caferuis-bc3': CAFBC3Presentation,
  'caferuis-bc4': CAFBC4Presentation,
  'caferuis-bc5': CAFBC5Presentation,
  'deeje': DEEJEPresentation,
  'deas': DEASPresentation,
  'bac-assp': BACASSPPresentation,
  'bac-assp-presentation': BACASSPPresentationGenerale,
  'bac-assp-b1-approche': BACASSPBloc1Approche,
  'bac-assp-b2-approche': BACASSPBloc2Approche,
  'bac-assp-b3-approche': BACASSPBloc3Approche,
  'bac-assp-b4-approche': BACASSPBloc4Approche,
  'bac-assp-pse': BACASSPPSEPresentation,
  'bac-assp-outils': BACASSPOutilsPresentation,
  'tp-iepe': TPIEPEPresentation,
  'tp-iepe-bloc1': TPIEPEBloc1Presentation,
  'tp-iepe-bloc2': TPIEPEBloc2Presentation,
  'tp-iepe-bloc3': TPIEPEBloc3Presentation,
  'tp-iepe-etude-bc1': TPIEPEEtudeCasBloc1,
  'deap-activite1': DEAPActivite1Presentation,
  'deap-activite1bis': DEAPActivite1bisPresentation,
  'deap-activite2': DEAPActivite2Presentation,
  'deap-activite3': DEAPActivite3Presentation,
  'deap-activite4': DEAPActivite4Presentation,
  'deap-activite5': DEAPActivite5Presentation,
  'deap-activite6': DEAPActivite6Presentation,
  'deap-activite7': DEAPActivite7Presentation,
  'deap-activite8': DEAPActivite8Presentation,
  'deap-activite9': DEAPActivite9Presentation,
  'deap-activite10': DEAPActivite10Presentation,
  'deap-activite11': DEAPActivite11Presentation,
  'deap': DEAPPresentation,
  'deeje-bloc1': DEEJEDC1Presentation,
  'deeje-bloc2': DEEJEDC1Presentation,
  'deeje-bloc3': DEEJEDC2Presentation,
  'deeje-bloc4': DEEJEDC2Presentation,
  'deeje-bloc5': DEEJEDC3Presentation,
  'deeje-bloc6': DEEJEDC3Presentation,
  'deeje-bloc7': DEEJEDC4Presentation,
  'deeje-bloc8': DEEJEDC4Presentation,
  'deeje-pedagogues': DEEJEPedagoguesPresentation,
  'deeje-glossaire': DEEJEGlossairePresentation,
  'deeje-lois': DEEJELoisPresentation,
  'oral-vae': OralVAEPresentation,
  'formation-langage': FormationLangagePresentation,
};

const PresentationRenderer = ({ presentationType }) => {
  const Component = PRESENTATION_MAP[presentationType] || VAEPresentation;
  return <Component />;
};

export default PresentationRenderer;
